import React from 'react'
import { UserAuth, HelpSection, PasswordReset } from '@rebeldotcom/ui'
import { Box, Stack } from '@rebeldotcom/components'
import Layout from '../components/layout'

const Account = () => {
  return (
    <Layout hasNavigation={false} location="/account">
      <Stack backgroundColor="greyLightest" minHeight="100vh" width="100%">
        <Box
          alignItems="flex-start"
          alignSelf="center"
          borderRadius={2}
          flexDirection={['column', 'column', 'row']}
          justifyContent={['space-between', 'space-between', 'center']}
          maxWidth="containers.lg"
          minWidth="32rem"
          mt={3}
          width={['100vw', '40rem', '100vw']}
        >
          <Box
            bg="white"
            justifyContent="center"
            mb={[3, 4, 0]}
            minWidth="32rem"
            mr={[0, 0, 4]}
            px={[3]}
            py={[3, 4]}
            width={['100vw', '40rem']}
          >
            <UserAuth id="account" showHeading />
          </Box>
          <Box
            bg="white"
            justifyContent="center"
            minWidth="32rem"
            px={[3]}
            py={[3, 4]}
            width={['100vw', '40rem']}
          >
            <HelpSection id="account-help-section" variant="light" />
          </Box>
        </Box>
      </Stack>
      <PasswordReset />
    </Layout>
  )
}

export default Account
